import React from "react";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import RoleAccess from "../../Components/RoleAccess";

const PlanTierActions = ({
  rowData,
  checked,
  onShare,
  onInvite,
  onArchive,
  onMoreActions,
  onWatchers,
}) => {
  const { t } = useTranslation("common");

  if (!rowData || checked || rowData.status === "ARCHIVED") {
    return null;
  }

  const disableTargetPlanShare = rowData.policy === "TARGET";
  const hasWatchers = Number(rowData?.watcherCount || 0) > 0;
  const stockClassName = classNames("border", {
    changePriceDisabled:
      rowData.policy !== "FIXED" ||
      (rowData.policy === "FIXED" && rowData.flex),
    changePriceDisable: rowData.quantity === "TIER" && rowData.flex,
  });
  const shareDisabled = rowData.policy === "CUSTOM" || rowData.policy === "SCHEDULE";

  return (
    <div className={`car-buttons tier_action_button ${stockClassName}`}>
      {shareDisabled ? (
        <Button
          disabled
          icon="pi pi-share-alt"
          className={`p-button action-button tier-archive-disabled`}
          tooltip={t("product.share_url")}
          id="disabled_icon"
          onClick={() => onShare(rowData)}
        />
      ) : (
        <Button
          icon="pi pi-share-alt"
          disabled={rowData.policy === "TARGET"}
          className="p-button action-button"
          id={disableTargetPlanShare ? "disable-share-action-button" : "action-button"}
          tooltip={t("product.share_plan")}
          onClick={() => onShare(rowData)}
        />
      )}
      <Button
        icon="pi pi-user-plus"
        className="p-button action-button"
        id="action-button"
        tooltip={t("product.invite")}
        tooltipOptions={{
          position: "bottom",
          mouseTrack: true,
          mouseTrackTop: 15,
        }}
        onClick={() => onInvite(rowData)}
      />
      <RoleAccess roles={["OWNER", "ADMIN"]}>
        <Button
          icon="pi pi-lock"
          className="p-button action-button"
          id="action-button pi-lock-disabled"
          tooltip={t("product.archive")}
          tooltipOptions={{
            position: "bottom",
            mouseTrack: true,
            mouseTrackTop: 15,
          }}
          onClick={() => onArchive(rowData)}
        />
      </RoleAccess>
      <RoleAccess roles={["OWNER", "ADMIN"]}>
        <Button
          type="button"
          tooltip={t("plan.plan_watchers")}
          className={`p-button action-button ${!hasWatchers ? "eye-greyed" : ""}`}
          id="action-button"
          icon={hasWatchers ? "pi pi-eye" : "pi pi-eye-slash"}
          onClick={() => onWatchers(rowData)}
        />
      </RoleAccess>
      <RoleAccess roles={["OWNER", "ADMIN"]}>
        <Button
          type="button"
          className="p-button action-button"
          id="action-button"
          icon="pi pi-ellipsis-v"
          onClick={(e) => onMoreActions(rowData, e)}
        />
      </RoleAccess>
    </div>
  );
};

export default PlanTierActions;
